import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import BaseSwitcher from '@r1-frontend/ui-react/components/controls/baseSwitcher';

import PageSection from '~/src/features/domru-tv/packages/components/PageSection';
import { TDetailsType } from '~/src/features/domru-tv/packages/types';
import { TState } from '~/src/store';

import SubscriptionsDetails from './subscriptions';
import TvPackagesDetails from './tvPackages';

import * as ST from './styled';

interface IProps {
    type: TDetailsType,
    onGoBack: () => void,
    hideSwitchers?: boolean,
}

const DetailsLayout = ({ type, onGoBack, hideSwitchers }: IProps): JSX.Element => {
    const { auth: { isAuth } } = useSelector((state: TState) => state);

    const [isHideActive, setIsHideActive] = useState(!!hideSwitchers);
    const [connectedItemsQuantity, setConnectedItemsQuantity] = useState(0);

    const { detailsTitle, detailsContent } = useMemo(() => {
        switch (type) {
            case 'packs':
                return {
                    detailsTitle: 'Пакеты каналов',
                    detailsContent: <TvPackagesDetails
                        isHideActive={isHideActive}
                        setConnectedItemsQuantity={setConnectedItemsQuantity}
                    />,
                };
            case 'subscriptions':
                return {
                    detailsTitle: 'Подписки на онлайн-кинотеатры',
                    detailsContent: <SubscriptionsDetails
                        isHideActive={isHideActive}
                        setIsHideActive={setIsHideActive}
                        setConnectedItemsQuantity={setConnectedItemsQuantity}
                        data-test='content'
                    />,
                };
            default:
                return {
                    detailsTitle: '',
                    detailsContent: <></>,
                };
        }
    }, [isHideActive, type]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <ST.LayoutWrapper>
            <PageSection>
                <ST.BackButton
                    type={btnTypes.GHOST}
                    size={btnSizes.SMALL}
                    text={'Назад'}
                    iconsSprite={'/static/images/icons/tv-packages-sprite.svg'}
                    symbolId={'back-arrow'}
                    onClick={onGoBack}
                    data-test='back-action'
                />
                <ST.HeadRow>
                    <ST.LayoutTitle data-test='title-text'>{detailsTitle}</ST.LayoutTitle>
                    {!hideSwitchers && isAuth && connectedItemsQuantity > 0 && (
                        <ST.FilterBlock>
                            <ST.FilterLabel>Не показывать подключенные ({connectedItemsQuantity})</ST.FilterLabel>
                            <BaseSwitcher
                                checked={isHideActive}
                                onChange={() => setIsHideActive(!isHideActive)}
                            />
                        </ST.FilterBlock>
                    )}
                </ST.HeadRow>
            </PageSection>
            {detailsContent}
        </ST.LayoutWrapper>
    );
};

export default DetailsLayout;
